<template>
  <div class="history-page">
    <!-- Header Section -->
    <div class="header">
      <div class="back-button" @click="goBack">
        <img src="@/assets/img/backleftarrow.png" alt="Back" />
      </div>
      <div class="title">
        <h1>充值记录</h1>
      </div>
    </div>

    <div
      class="history-title-bar"
      v-if="historyItems && historyItems.length > 0"
    >
      <div class="title1">交易类别名称/时间</div>
      <div class="title2">算力值</div>
    </div>

    <!-- History List -->
    <div class="history-list" v-if="historyItems && historyItems.length > 0">
      <div
        class="history-item"
        v-for="(item, index) in historyItems"
        :key="index"
      >
        <div class="history-details">
          <div class="history-title">{{ item.description }}</div>
          <div class="history-date">{{ item.createdTime }}</div>
        </div>
        <div class="history-change">
          <div class="history-amount">
            {{ item.changeValue > 0 ? "+" : "" }}{{ item.type === 2 ? formatBalanceRecordDays(item.changeValue) : formatPoint(item.changeValue) }}
          </div>
          <div class="history-balance">余额：{{ item.type === 2 ? formatBalanceRecordDays(item.lastValue) : formatPoint(item.lastValue) }}</div>
        </div>
      </div>
    </div>

    <div class="empty-state" v-if="historyItems.length === 0">
      <div class="empty-title">暂无充值记录</div>
      <div class="empty-text">
        返回到我的页面去充值算力值后选择兑换合适的服务器套餐
      </div>
      <div class="empty-button" @click="goRecharge()">去充值</div>
    </div>

    <!-- Add ICP info and Tabbar at the bottom -->
    <the-tabbar active-page="user" />
  </div>
</template>

<script>
import TheTabbar from "@/components/theTabbar.vue";
import { fetchRechargeRecord } from "../../api/theApi";
import { formatPoint, formatBalanceRecordDays } from "@/utils/formatPoint";

export default {
  name: "RechargeHistory",
  components: {
    TheTabbar,
  },
  data() {
    return {
      userName: localStorage.getItem("username"),
      historyItems: [],
    };
  },
  created() {
    this.init();
  },
  methods: {
    formatPoint,
    formatBalanceRecordDays,
    async init() {
      const { data } = await fetchRechargeRecord();
      this.historyItems = data;
    },
    goBack() {
      // 检查是否有足够的历史记录可以回退
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        // 如果没有历史记录可回退，则跳转到用户页面
        this.$router.replace('/subscription');
      }
    },
    goRecharge() {
      this.$router.replace('/subscription?activeTab=credit')
    }
  },
};
</script>

<style lang="less" scoped>
.history-page {
  min-height: 100vh;
  background-color: #f5f5f5;
  padding-bottom: 70px; /* Add padding for the tabbar */
}

/* Header Styles */
.header {
  padding: 16px;
  color: #000000;
  position: relative;
  display: flex;
  align-items: center;
  height: 64px;
}

.back-button {
  position: absolute;
  left: 16px;

  img {
    width: 24px;
    height: 24px;
  }
}

.title {
  flex: 1;
  text-align: center;

  h1 {
    font-size: 18px;
    font-weight: 500;
    margin: 0;
  }
}

/* History List Styles */
.history-list {
  box-sizing: border-box;
  width: calc(100% - 32px);
  padding: 16px;
  margin: 10px 16px 0;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 16px;
  background: #ffffff;
}

.history-item {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 0;
}

.history-details {
  flex: 1;
}

.history-title {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 4px;
}

.history-date {
  font-size: 11px;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.6);
}

.history-change {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  gap: 4px;
}

.history-amount {
  font-weight: 700;
  font-size: 15px;
  letter-spacing: 0px;
  text-align: right;
  color: #000000;
}

.history-balance {
  font-weight: 400;
  font-size: 11px;
  line-height: 1.5;
  letter-spacing: 0px;
  color: rgba(0, 0, 0, 0.6);
}

.history-title-bar {
  margin-top: 16px;
  box-sizing: border-box;
  width: 100%;
  padding: 0 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: PingFang SC;
  font-weight: 600;
  font-size: 12px;
  line-height: 1.5;
  letter-spacing: 0px;
  color: #00000050;
}

.empty-state {
  width: 100%;
  box-sizing: border-box;
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0px 66px;
}

.empty-title {
  font-weight: 600;
  font-size: 20px;
  line-height: 1.5;
  letter-spacing: 0px;
  text-align: center;
  color: #000000;
}

.empty-text {
  margin-top: 8px;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.5;
  letter-spacing: 0px;
  text-align: center;
  color: rgba(0, 0, 0, 0.5);
}

.empty-button {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #000000;
  width: 177px;
  height: 40px;
  border-radius: 80px;
  margin: 32px auto 0;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0px;
  text-align: center;
  color: #ffffff;
}
</style>
